import { createReducer, on } from '@ngrx/store';
import { Item } from '@app/store/form-options/models';
import { AssessorAssignments } from '../models';
import { assessorAssignmentsActions } from '../actions/assessor-assignments.actions';

export interface AssessorAssignmentsState {
    loaded: boolean | null;
    loading: boolean | null;
    saving: boolean;
    saved: boolean;
    error: number | null;
    assignments: AssessorAssignments | null;

    schoolsLoaded: boolean | null;
    schoolsLoading: boolean;
    schools: Item[];

    coursesLoaded: boolean | null;
    coursesLoading: boolean;
    courses: Item[];

    packagesLoaded: boolean | null;
    packagesLoading: boolean;
    packages: Item[];
}

export const initialState: AssessorAssignmentsState = {
    loaded: null,
    loading: null,
    saving: false,
    saved: false,
    error: null,
    assignments: null,

    schoolsLoaded: null,
    schoolsLoading: false,
    schools: [],

    coursesLoaded: null,
    coursesLoading: false,
    courses: [],

    packagesLoaded: null,
    packagesLoading: false,
    packages: [],
};

export const assessorAssignmentsReducer = createReducer(
    initialState,
    // Assignments
    on(assessorAssignmentsActions.getAssignments, (state): AssessorAssignmentsState => ({
        ...state,
        loading: true,
        loaded: null,
        error: null,
    })),
    on(assessorAssignmentsActions.getAssignmentsSuccess, (state, { payload }): AssessorAssignmentsState => ({
        ...state,
        loading: false,
        loaded: true,
        assignments: payload,
    })),
    on(assessorAssignmentsActions.getAssignmentsError, (state, { code }): AssessorAssignmentsState => ({
        ...state,
        loading: false,
        loaded: false,
        error: code,
    })),

    on(assessorAssignmentsActions.updateAssignments, (state): AssessorAssignmentsState => ({
        ...state,
        saving: true,
        saved: false,
    })),
    on(assessorAssignmentsActions.updateAssignmentsSuccess, (state, { payload }): AssessorAssignmentsState => ({
        ...state,
        saving: false,
        saved: true,
        assignments: payload,
    })),
    on(assessorAssignmentsActions.updateAssignmentsError, (state): AssessorAssignmentsState => ({
        ...state,
        saving: false,
        saved: false,
    })),

    // Schools
    on(assessorAssignmentsActions.getSchools, (state): AssessorAssignmentsState => ({
        ...state,
        schoolsLoading: true,
    })),
    on(assessorAssignmentsActions.getSchoolsSuccess, (state, { payload }): AssessorAssignmentsState => ({
        ...state,
        schoolsLoaded: true,
        schoolsLoading: false,
        schools: payload,
    })),
    on(assessorAssignmentsActions.getSchoolsError, (state): AssessorAssignmentsState => ({
        ...state,
        schoolsLoaded: false,
        schoolsLoading: false,
    })),

    // Courses
    on(assessorAssignmentsActions.getCourses, (state): AssessorAssignmentsState => ({
        ...state,
        coursesLoading: true,
    })),
    on(assessorAssignmentsActions.getCoursesSuccess, (state, { payload }): AssessorAssignmentsState => ({
        ...state,
        coursesLoaded: true,
        coursesLoading: false,
        courses: payload,
    })),
    on(assessorAssignmentsActions.getCoursesError, (state): AssessorAssignmentsState => ({
        ...state,
        coursesLoaded: false,
        coursesLoading: false,
    })),

    // Packages
    on(assessorAssignmentsActions.getPackages, (state): AssessorAssignmentsState => ({
        ...state,
        packagesLoading: true,
    })),
    on(assessorAssignmentsActions.getPackagesSuccess, (state, { payload }): AssessorAssignmentsState => ({
        ...state,
        packagesLoaded: true,
        packagesLoading: false,
        packages: payload,
    })),
    on(assessorAssignmentsActions.getPackagesError, (state): AssessorAssignmentsState => ({
        ...state,
        packagesLoaded: false,
        packagesLoading: false,
    })),

    on(assessorAssignmentsActions.clear, (): AssessorAssignmentsState => ({ ...initialState })),
);
